<template>
  <tr class="text-sm font-semibold">
    <!-- STATUS -->
    <td>
      <div
        class="row relative col-span-2 overflow-hidden font-bold text-gray-50"
      >
        <div class="flex flex-col gap-1">
          <span class="relative z-10 font-bold">
            {{ data.label }} {{ data.bo_target }}{{ targetType }}
          </span>
          <span class="text-xs font-normal text-gray-400">
            ID: {{ data.bo_id }}
          </span>
        </div>
      </div>
    </td>

    <!-- NOME/TARGET -->
    <td>
      <div
        class="row relative col-span-2 overflow-hidden font-bold text-gray-50"
      >
        <span class="font-bold">
          {{ data.bo_status }}
        </span>
      </div>
    </td>

    <!-- DIREÇÃO -->
    <td>
      <div class="row col-span-1 gap-2">
        <div class="flex flex-col gap-2">
          <div
            class="flex items-center rounded-full pr-2 text-gray-50"
            :class="
              data.bo_direction == 'BUY'
                ? 'bg-ontick-green-600'
                : 'bg-ontick-orange-600'
            "
          >
            <i v-if="data.bo_direction == 'BUY'" v-html="$icons.trend_up"></i>
            <i
              v-else-if="data.bo_direction == 'SELL'"
              v-html="$icons.trend_down"
            ></i>
            <span class="direction-shadow text-[10px] uppercase">
              {{ data.bo_direction == "BUY" ? "Sobe" : "Desce" }}
            </span>
          </div>
          <!-- <span class="text-xs font-normal text-gray-400">
          {{ data.bo_target }}{{ targetType }}
        </span> -->
        </div>
      </div>
    </td>

    <!-- ENTRADA -->
    <td>
      <div class="row col-span-2">
        <div class="flex flex-col gap-1">
          <span>
            {{ data.bo_entry_price || "-" }}
          </span>
          <span
            class="text-xs font-normal text-gray-400"
            v-if="data.bo_entry_datetime"
          >
            {{ moment(data.bo_entry_datetime).format("DD/MM/YYYY HH:mm:ss") }}
          </span>
          <span class="text-xs font-normal text-gray-400" v-else> - </span>
        </div>
      </div>
    </td>

    <!-- SAÍDA -->
    <td>
      <div class="row col-span-2">
        <div class="flex flex-col gap-1">
          <span v-if="data.bo_exit_price">
            {{ data.bo_exit_price || "-" }}
          </span>
          <span v-else> - </span>
          <span
            class="text-xs font-normal text-gray-400"
            v-if="data.bo_exit_datetime"
          >
            {{ moment(data.bo_exit_datetime).format("DD/MM/YYYY HH:mm:ss") }}
          </span>
          <span class="text-xs font-normal text-gray-400" v-else> - </span>
        </div>
      </div>
    </td>

    <!-- MULTIPLICADOR -->
    <td>
      <div class="row col-span-1 flex items-center gap-2">
        <span> {{ data.bo_multiplier }}x </span>
      </div>
    </td>

    <!-- RESULTADO -->
    <td>
      <div class="row col-span-2 flex items-center gap-4">
        <span v-if="data.status == 'NEW'"> Aguardando entrada </span>
        <div v-else class="flex items-center gap-2">
          <i v-html="icons.play_green" v-if="data.bo_profit > 0"></i>
          <i v-html="icons.play_red" v-else-if="data.bo_profit < 0"></i>
          <i class="h-3 w-3 rounded-full bg-gray-500" v-else></i>
          <span v-if="data.bo_profit">
            {{ data.bo_profit | currency }}
          </span>
          <span v-else> {{ 0 | currency }} </span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import { iconsSet as icons } from "../../../assets/icons/icons";
export default {
  props: {
    data: {
      type: Object,
    },
  },

  data() {
    return {
      icons,
    };
  },

  methods: {},

  computed: {
    ...mapGetters({
      getSymbolData: "bests/getSymbolData",
    }),
    targetType() {
      switch (this.data.best_target_type) {
        case "POINTS":
          return "p";
        case "PERCENT":
          return "%";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../styles/bests.scss";
</style>
